<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar tipo de documento" : "Nuevo tipo de documento" }}
      </h1>
    </div>

    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card tag="article" no-body style="max-width: 760px" class="custom-card">
          <b-card-header header-tag="section" class="custom-card-header d-flex align-items-center">
            <h3>{{ editing ? "Datos del tipo de documento" : "Datos del nuevo tipo de documento" }}</h3>
          </b-card-header>

          <b-card-body class="custom-card-body p-0">
            <section class="form-section mb-0">
              <div class="row">

                <!-- Código -->
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="code">Código <span class="text-danger">*</span></label>
                    <input
                      id="code"
                      type="text"
                      v-model="form.code"
                      autocomplete="off"
                      placeholder="Ej: DNI"
                      class="custom-form-control"
                      :class="{ 'custom-form-control-error': $v.form.code.$error }"
                    />
                    <FormError
                      v-if="$v.form.code.$error && !$v.form.code.required"
                      message="El código es requerido"
                    />
                  </div>
                </div>

                <!-- Nombre -->
                <div class="col-md-8">
                  <div class="form-group">
                    <label for="name">Nombre <span class="text-danger">*</span></label>
                    <input
                      id="name"
                      type="text"
                      v-model="form.name"
                      autocomplete="off"
                      placeholder="Nombre del tipo de documento"
                      class="custom-form-control"
                      :class="{ 'custom-form-control-error': $v.form.name.$error }"
                    />
                    <FormError
                      v-if="$v.form.name.$error && !$v.form.name.required"
                      message="El nombre es requerido"
                    />
                  </div>
                </div>

                <!-- Descripción -->
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="description">Descripción</label>
                    <textarea
                      id="description"
                      v-model="form.description"
                      placeholder="Descripción del tipo de documento"
                      class="custom-form-control"
                      rows="3"
                    ></textarea>
                  </div>
                </div>

                <!-- Obligatorio -->
                <div class="col-md-12">
                  <div class="form-group">
                    <b-form-checkbox v-model="form.isRequired" switch>
                      <strong>Obligatorio para todos los empleados</strong>
                    </b-form-checkbox>
                    <small class="text-muted d-block mt-1">
                      Si está marcado, los empleados que no tengan este documento aparecerán con advertencia en la lista y ficha.
                    </small>
                  </div>
                </div>

              </div>

              <div class="form-group-buttons text-right">
                <router-link :to="{ name: 'document-type-list' }" class="button button-light">
                  {{ editing ? "Volver" : "Cancelar" }}
                </router-link>
                <button class="button button-primary" type="submit">Guardar</button>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, FormError } from "wize-admin";
import { required } from "vuelidate/lib/validators";
import { DocumentTypeService } from "@/core/services";

export default {
  components: { FormError },

  data() {
    return {
      editing: false,
      form: {
        code:        null,
        name:        null,
        description: null,
        isRequired:  false,
      },
    };
  },

  validations: {
    form: {
      code: { required },
      name: { required },
    },
  },

  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },

  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });
        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        const data = {
          code:        this.form.code,
          name:        this.form.name,
          description: this.form.description || null,
          isRequired:  !!this.form.isRequired,
        };

        let response;
        if (!this.editing) response = await DocumentTypeService.save(data);
        else response = await DocumentTypeService.update(this.$route.params.id, data);

        Alert.success("Se almacenó la información correctamente");
        if (!this.editing) {
          this.$router.push({
            name:   "document-type-edit",
            params: { id: response.payload.id },
          });
          this.editing = true;
        }
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors ? ex.errors.message : "Error al guardar");
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },

    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const payload = (await DocumentTypeService.get(id)).payload;
        this.form = {
          code:        payload.code,
          name:        payload.name,
          description: payload.description,
          isRequired:  !!payload.isRequired,
        };
        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors ? e.errors.message : "Error al cargar el tipo de documento");
        this.$router.push({ name: "document-type-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },

  async created() {
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped></style>
